<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: lwq
 * @LastEditTime: 2021-08-20 09:40:06
-->
<template>
  <div>
    <mrc_ess_skeleton_loader
      :loading="$store.state.uuid ? skeletonloading : false"
    >
      <mrc_ess_table
        :headers="headers"
        hideAddBtn
        :paginationOptions="options"
        @turnPage="getlist"
        :slotKey="['status', 'created_utc_datetime']"
        :isLoading="loading"
        :items="desserts"
      >
        <template v-slot:item.created_utc_datetime="{ item }">
          {{ moment(item.created_utc_datetime).format("YYYY/MM/DD HH:mm:ss") }}
        </template>

        <!-- 状态 -->
        <template v-slot:item.status="{ item }">
          <mrc_ess_viewbtn :is_used="item.status"> </mrc_ess_viewbtn>
        </template>
      </mrc_ess_table>
    </mrc_ess_skeleton_loader>
  </div>
</template>

<script>
import { getLogList, executeTimedTask } from "@/service/api/timedTask.js";
import moment from "moment";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      skeletonloading: true,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,

      desserts: [],
    };
  },
  computed: {
    menulist() {
      return [
        { name: this.$t("label_Edit") },
        { name: this.$t("label_Executed_immediately") },
        { name: this.$t("label_delete") },
      ];
    },
    headers() {
      return [
        { text: "ID", align: "start", value: "job_log_id", sortable: false },
        {
          text: this.$t("label_The_name_of_the_task"),
          align: "start",
          value: "job_name",
          sortable: false,
        },
        {
          text: this.$t("label_grouping"),
          value: "job_group",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("label_Call_target_string"),
          value: "invoke_target",
          sortable: false,
        },
        {
          text: this.$t("label_time_consuming"),
          value: "job_message",
          sortable: false,
        },
        {
          text: this.$t("label_state"),
          value: "status",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_execution_time"),
          value: "created_utc_datetime",
          sortable: false,
        },
      ];
    },
  },
  created() {},
  watch: {
    $route(v) {
      if (v.name == "timedTask") {
        this.getlist();
      }
    },
  },
  mounted() {
    this.getlist();
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  beforeDestroy() {},
  methods: {
    async getlist(obj) {
      this.skeletonloading = true;
      this.loading = true;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = obj;
      }
      const res = await getLogList({
        uuid: this.$store.state.uuid,
        pindex: this.options.cpage,
        psize: this.options.pagesize,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        // .map((item, index) => {
        //   item.created_utc_datetime = moment(item.created_utc_datetime).format(
        //     'YYYY/MM/DD HH:mm:ss'
        //   )
        //   item.logID = index + 1
        //   return item
        // })
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
      }
      this.loading = false;
      this.skeletonloading = false;
    },
    // immediately () {
    //   this.$myConfirm({ content: '确认要立即执行该定时任务?' }).then(res => {
    //     executeTimedTask({ uuid: this.$store.state.uuid }).then(res => {
    //       if (res.code === '200') {
    //
    //         this.getlist()
    //       }
    //       else {
    //
    //       }
    //     })
    //   }).catch(err => { })
    // },
    // addemailtemplate () {
    //   this.$store.commit('set_subPage_name', '')
    //   this.$store.commit('set_uuid', '')
    //   this.$store.commit('set_iconstatus', '')  //行内进图标显示
    //   this.$router.push({
    //     name: 'addemailtemplate'
    //   })
    // },
    // godetail (item) {
    //   this.$store.commit('set_iconstatus', true)  //行内进图标显示
    //   this.$store.commit('set_subPage_name', item.template_name)
    //   this.$store.commit('set_uuid', item.uuid)  //
    //   this.$router.push({
    //     name: 'detailemailtemplate'
    //   })
    // },
    // handleClick ({ index }, item) {
    //   switch (index) {
    //     case 0:
    //       this.$store.commit('set_subPage_name', item.template_name)
    //       this.$store.commit('set_iconstatus', false)  //行内进图标显示
    //       this.$store.commit('set_uuid', item.uuid)  //
    //       this.$router.push({
    //         name: 'detailemailtemplate'
    //       })
    //       break
    //     case 1:
    //       this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
    //         deleteemailtemplate({ uuid: item.uuid }).then(res => {
    //           if (res.code === '200') {
    //             this.$Message({ text: this.$t('message_The_deletion_was_successful') })
    //            if (this.desserts.length == 1) this.options.cpage--
    //             this.getlist()
    //           }
    //         })
    //       })
    //       break
    //   }
    // },
  },
};
</script>

<style scoped></style>
